import React from 'react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link'
  size?: 'default' | 'sm' | 'lg' | 'icon'
  children: React.ReactNode
}

export function Button({ 
  variant = 'default', 
  size = 'default', 
  className = '', 
  children, 
  ...props 
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background'
  
  const variantClasses = {
    default: 'bg-throttle-cyan-500 text-throttle-navy-900 hover:bg-throttle-cyan-400 shadow-md hover:shadow-lg transition-shadow',
    destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90 bg-red-600 text-white hover:bg-red-700',
    outline: 'border border-throttle-cyan-500 hover:bg-throttle-cyan-500/10 hover:text-throttle-cyan-600 text-throttle-cyan-600',
    secondary: 'bg-throttle-navy-700 text-white hover:bg-throttle-navy-600',
    ghost: 'hover:bg-throttle-cyan-500/10 hover:text-throttle-cyan-600',
    link: 'underline-offset-4 hover:underline text-throttle-cyan-600'
  }
  
  const sizeClasses = {
    default: 'min-h-[48px] py-3 px-4',
    sm: 'min-h-[44px] px-3 rounded-md',
    lg: 'min-h-[52px] px-6 sm:px-8 rounded-md',
    icon: 'min-h-[44px] min-w-[44px]'
  }

  return (
    <button 
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}